import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, reset } from 'redux-form';
import { flowRight as compose } from 'lodash';
import { gql } from '@apollo/client';
import { connect } from 'react-redux';
// Style
import { Button } from 'react-bootstrap';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
// Translation
import { FormattedMessage, injectIntl } from 'react-intl';
import CommonFormComponent from '../../CommonField/CommonFormComponent';
import validate from './validate';
import showToaster from '../../../helpers/toasterMessages/showToaster';
import { withMutation } from '../../../hoc/withGraphql';
import { demoRestriction } from '../../../helpers/DemoRestriction/demoRestriction';

import cs from '../../../components/commonStyle.css';
import s from './ChangeAdminForm.css';
import messages from '../../../locale/jsonMessages';

class ChangeAdminForm extends Component {

  static propTypes = {
    title: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    this.submitForm = this.submitForm.bind(this);
  }


  async submitForm(values, dispatch) {
    const { mutate, demoRestriction } = this.props;
    const isRestrict = await demoRestriction({});
    if (isRestrict) return;
    const { data } = await mutate({ variables: values });
    if (data?.changeAdminUser) {
      if (data?.changeAdminUser?.status === '200') {
        showToaster({ messageId: 'adminAccessDetails', toasterType: 'success' })
      } else if (data.changeAdminUser.status === 'email') {
        showToaster({ messageId: 'existAdminUser', toasterType: 'error' })
      } else {
        showToaster({ messageId: 'adminDetailsFailed', toasterType: 'error' })
      }
    }
    dispatch(reset('ChangeAdminForm'));
  }

  render() {

    const { error, handleSubmit, submitting, dispatch, title, isSuperAdmin } = this.props;
    const { formatMessage } = this.props.intl;

    return (
      <div className='siteAdminCenterContainer siteAdminCenterContainerBox'>
        <h1 className='siteAdminHeading'><FormattedMessage  {...messages.changeAdminEmailPassword} /></h1>
        <form onSubmit={handleSubmit(this.submitForm)}>
          {error && <strong>{formatMessage(error)}</strong>}
          <div className="oneColumnGrid">
            {isSuperAdmin &&
              <Field name="email"
                type="text"
                component={CommonFormComponent}
                placeholder={formatMessage(messages.email)}
                labelText={formatMessage(messages.email)}
                note={formatMessage(messages.changeAdminPasswordDesc)}
                inputClass='commonInputField'
              />
            }

            <Field
              name="password"
              type="password"
              component={CommonFormComponent}
              placeholder={formatMessage(messages.password)}
              labelText={formatMessage(messages.password)}
              inputClass='commonInputField'
              isRequiredInput
            />

            <Field
              name="confirmPassword"
              type="password"
              component={CommonFormComponent}
              placeholder={formatMessage(messages.confirmPassword)}
              labelText={formatMessage(messages.confirmPassword)}
              inputClass='commonInputField'
              isRequiredInput
            />
          </div>
          <div className={cx(cs.spaceTop4, 'singleBtnFlexEnd')}>
            <Button className={cx(cs.btnPrimary)} type="submit" disabled={submitting} ><FormattedMessage  {...messages.save} /></Button>
          </div>
        </form>
      </div>
    );
  }

}

ChangeAdminForm = reduxForm({
  form: 'ChangeAdminForm', // a unique name for this form
  validate
})(ChangeAdminForm);


const mapState = (state) => ({
  isSuperAdmin: state.runtime.isSuperAdmin,
});

const mapDispatch = {
  demoRestriction
};

export default compose(injectIntl,
  withStyles(cs, s),
  connect(mapState, mapDispatch),
  withMutation(gql`
    mutation changeAdminUser($email: String, $password: String!) {
      changeAdminUser (email: $email, password: $password) {
        status
      }
    }
  `),
)(ChangeAdminForm);